let minToHoursMin = function(totalTimeInMin) {
  return Math.floor(totalTimeInMin / 60) + 't ' + (totalTimeInMin % 60) + 'm';
};
let getAppLoc = function(configData) {
  let locObj = window.location;
  let appLoc = 'localhost';
  $.each(configData, function(key, val) {
    if (val.hostname === locObj.hostname && val.pathname === locObj.pathname) {
      appLoc = key;
      console.log('%cappLoc:' + appLoc, 'color:orange;');
      return false;
    }
  });

  return appLoc;
};
let emptyModal = function() {
  $('#contentModal #modalTitle').empty();
  $('#contentModal .modal-body').empty();
  $('.modal-footer')
    .empty()
    .show();
  $('.modal-title').text('');
  $('.modal-dialog').removeClass(
    'modal-sm modal-lg modal-xlg preview editContent topLink modal-dialog-centered'
  );
};
export { minToHoursMin, getAppLoc, emptyModal };
